<template>
  <v-dialog v-model="dialog" width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        x-small
        v-on="on"
      >
        설정
      </v-btn>
    </template>
    <div>
      <v-card class="card-container">
        <v-card-title class="headline">
          설정
        </v-card-title>
        <v-list class="card-list">
          <v-list-item-group ref="test">
            <v-list-item v-for="(item, idx) in flatHeaders" :key="item.key || idx">
              <v-list-item-content class="ml-6">
                <label>
                  <div class="d-flex">
                    <v-checkbox
                      v-model="item.isActive"
                      :label="item.text"
                      dense
                      hide-details
                      :ripple="false"
                      @change="e => onChangeIgnore(e, item.key)"
                    />
                  </div>
                </label>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="confirm">
            적용
          </v-btn>
          <v-btn color="red darken-1" text @click="cancel">
            취소
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
/**
 * infinityScrollTable에서 보여질 컬럼을 설정하는 Component 입니다.
 */
import {cloneDeep} from "lodash";

const IGNORE_HEADER_KEY = 'ignoreHeader:'

export default {
  name: "IgnoreHeaderConfigModal",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      dialog: false,
      internalValue: []
    }
  },

  computed: {
    flatHeaders: {
      get() {
        const result = this.leaf(this.headers)
        return result
      },

      set(value) {
        console.log(value)
      },
    }
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.internalValue = cloneDeep(newValue)
      }
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    /**
     * 초기화
     * localStorage 에 저장된 정보가 있으면 해당 정보로 초기화
     */
    init() {
      const ignoreHeaders = localStorage.getItem(IGNORE_HEADER_KEY)
      if(!ignoreHeaders) return
      const jsonIgnoreHeaders = JSON.parse(ignoreHeaders)
      const path = window.location.pathname
      if(!jsonIgnoreHeaders[path])
        return;
      this.internalValue = jsonIgnoreHeaders[path]
      this.$emit('input', this.internalValue);
    },

    /**
     * 설정 완료
     * localStorage 에 설정 정보 저장
     */
    confirm() {
      const ignoreHeaders = localStorage.getItem(IGNORE_HEADER_KEY)
      const jsonIgnoreHeaders = ignoreHeaders ? JSON.parse(ignoreHeaders) : {}
      const path = window.location.pathname
      jsonIgnoreHeaders[path] = this.internalValue
      localStorage.setItem(IGNORE_HEADER_KEY, JSON.stringify(jsonIgnoreHeaders))

      this.$emit('input', this.internalValue);
      this.dialog = false;
    },

    /**
     * 취소
     * 설정 정보 원복
     */
    cancel() {
      this.internalValue = cloneDeep(this.value)
      this.dialog = false;
    },

    /**
     * 초기화
     * 마지막 노드만 반환
     */
    leaf(arr, parent) {
      const result = []
      arr.forEach(e => {
        if (!e.child || e.child.length < 1) {
          result.push({
            text: (parent ? parent.text + ' > ' : '') + e.text,
            key: e.key,
            isActive: !this.internalValue.includes(e.key)
          })
        } else {
          result.push(...this.leaf(e.child, e))
        }
      })
      return result
    },

    /**
     * 설정이 바뀔때마다 호출
     * @param value
     * @param key
     */
    onChangeIgnore(value, key) {
      if (this.internalValue.includes(key)) {
        const idx = this.internalValue.findIndex(e => e === key)
        this.internalValue.splice(idx, 1)
      } else {
        this.internalValue.push(key)
      }
    }
  }
}
</script>

<style scoped>
.card-container {
  height: 550px;
}

.card-list {
  overflow-y: scroll;
  border: 1px solid grey;
  height: 410px;
  margin: 10px;
}

.text-one-line {
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

>>> .v-input--selection-controls.v-input{
  margin: 0;
}

</style>